import styled, { css } from 'styled-components'
import { theme } from 'constants/theme'

const CARECO_CONTROL_ROW_HEIGHT = '28px'
const CARECO_HEADLINE_OFFSET_TOP = '30px'
const CARECO_HEADLINE_OFFSET_BOTTOM = '0px'

const DateControl = styled.div<{ $isCarecoAdmin?: boolean }>`
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? `${CARECO_HEADLINE_OFFSET_TOP} 0 ${CARECO_HEADLINE_OFFSET_BOTTOM}` : '0')};
  justify-content: flex-start;
  height: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? 'auto' : '92px')};
  flex-shrink: 0;

  & div.react-bootstrap-daterangepicker-container {
    z-index: 2;
  }
`

const ControlsColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  width: max-content;
  max-width: 100%;
`

const ControlRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  min-height: ${CARECO_CONTROL_ROW_HEIGHT};
  flex-wrap: nowrap;
`

const CustomDateRangeWrap = styled.div<{ $isCarecoAdmin?: boolean }>`
  width: 42%;
  min-height: ${CARECO_CONTROL_ROW_HEIGHT};
  align-self: flex-end;
  margin: 0;
  & > div {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
  }

  input {
    width: 100% !important;
    height: ${CARECO_CONTROL_ROW_HEIGHT} !important;
    margin: 0 !important;
    font-size: 12px;
    padding: 0 12px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid ${theme.tabs.dateButton.border};
    background: var(--color-background-primary, #fff);
    color: ${theme.tabs.dateButton.text()};
    cursor: pointer;
    box-shadow: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '0 1px 2px rgba(0, 0, 0, 0.06)' : 'none')};
  }
`

const Frequency = styled.div<{ $isCarecoAdmin?: boolean }>`
  text-align: right;
  margin-top: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '0' : '16px')};
  width: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '100%' : 'max-content')};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: nowrap;
  min-height: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? CARECO_CONTROL_ROW_HEIGHT : 'auto')};
`

const FrequencyButton = styled.button<{ isSelected: boolean; isCarecoAdmin?: boolean }>`
  background: ${({ isSelected, isCarecoAdmin }) => {
    if (isCarecoAdmin && isSelected) return 'var(--careco-primary)'
    if (isSelected) return 'var(--color-button-secondary)'
    return theme.tabs.dateButton.color
  }};
  border: 1px solid ${({ isSelected, isCarecoAdmin }) => {
    if (isCarecoAdmin && isSelected) return 'var(--careco-primary)'
    if (isSelected) return 'var(--color-button-secondary)'
    return theme.tabs.dateButton.border
  }};
  box-sizing: border-box;
  color: ${({ isSelected, isCarecoAdmin }) => {
    if (isCarecoAdmin && isSelected) return '#fff'
    if (isSelected) return 'var(--color-text-on-secondary)'
    return theme.tabs.dateButton.text()
  }};
  padding: ${({ isCarecoAdmin }) => (isCarecoAdmin ? '10px 16px' : '14px 18px')};
  text-align: center;
  font-size: 14px;
  font-weight: ${({ isCarecoAdmin }) => (isCarecoAdmin ? '500' : '400')};
  outline: none !important;
  cursor: pointer;
  white-space: nowrap;

  ${({ isCarecoAdmin }) => isCarecoAdmin && css`
    &:not(:first-of-type) {
      border-left: none;
    }

    &:hover:not(:disabled) {
      opacity: 0.92;
    }
  `}

  &:first-of-type {
    border-radius: 10px 0 0 10px;
  }

  &:last-of-type {
    border-radius: 0 10px 10px 0;
  }
`

const FrequencyButtons = styled.div<{ $isCarecoAdmin?: boolean }>`
  display: flex;
  overflow: hidden;
  border-radius: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '10px' : '0')};
  box-shadow: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '0 1px 2px rgba(0, 0, 0, 0.06)' : 'none')};
`

const OrganizationSelect = styled.select`
  background: var(--color-background-primary, #fff);
  border: 1px solid ${theme.tabs.dateButton.border};
  border-radius: 10px;
  padding: 14px 18px;
  font-size: 14px;
  color: ${theme.tabs.dateButton.text()};
  outline: none;
  cursor: pointer;
  min-width: 180px;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 18px center;
  padding-right: 40px;
`

const ExportButton = styled.button<{ $isCarecoAdmin?: boolean }>`
  background: var(--color-background-primary, #fff);
  border: 1px solid ${theme.tabs.dateButton.border};
  border-radius: 10px;
  padding: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '10px 16px' : '14px 18px')};
  font-size: 14px;
  font-weight: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '500' : '400')};
  color: ${theme.tabs.dateButton.text()};
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: ${({ $isCarecoAdmin }) => ($isCarecoAdmin ? '0 1px 2px rgba(0, 0, 0, 0.06)' : 'none')};

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    opacity: 0.92;
  }
`

export {
  DateControl,
  ControlsColumn,
  ControlRow,
  CustomDateRangeWrap,
  Frequency,
  FrequencyButton,
  FrequencyButtons,
  OrganizationSelect,
  ExportButton,
}
